import { MockERC20Abi } from '@shared/Abis'
import { ERC20Wei } from '@shared/conversions'
import { logOT } from '@shared/loggingShared'
import { EthAddr } from '@shared/SchemaTypes'
import { Contract, ethers } from 'ethers'

// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export const transferLiquidityAsset = async (
  liquidityAssetAddr: EthAddr,
  addr: EthAddr,
  amount: ERC20Wei,
  signer: ethers.Signer
): Promise<number> => {
  const transferAmount = BigInt(amount).toString()

  const usdc = new Contract(liquidityAssetAddr, MockERC20Abi, signer)

  const startingBalance = await usdc.balanceOf(addr)
  //  const sourceBalance = await usdc.balanceOf(signer.getAddress())

  const txMint = await usdc.transfer(addr, transferAmount)
  await txMint.wait(0)
  const endingBalance = await usdc.balanceOf(addr)

  logOT.debug(
    `Transfer ${amount}USDC to ${addr} starting balance ${Number(startingBalance) / 1e6}  ending ${
      Number(endingBalance) / 1e6
    }`
  )
  return Number(endingBalance) / 1e6
}
